import { memo } from 'react';

import type { ColumnWidth } from '@/components/ui/table/columnWidth';
import type { TextView } from '@/components/ui/widget/views/text/text.view.type';
import type { WidgetData } from '../../widget.type';
import type { EmptyView } from './empty.view.type';

// simple text to display
const EmptyViewImpl = memo(() => (
  <div className="size-full cursor-not-allowed" />
));

// sort defaults to text on path
const getSortConfig = (_view: EmptyView): TextView => ({
  type: 'text',
  path: ''
});

// filtering defaults to text search on path
const getFilterConfig = (_view: EmptyView): TextView => ({
  type: 'text',
  path: ''
});

// width defaults to 'medium'
const getDefaultWidth = (): ColumnWidth => 'medium';

// stringifies data at path
const getStringifyFunction = () => (_data: WidgetData) => {};

export const emptyViewProvider = {
  component: EmptyViewImpl,
  getSortConfig,
  getFilterConfig,
  getDefaultWidth,
  getStringifyFunction
};
